import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { TabbedPageLayoutComponent } from 'app/layout/page-layouts/tabbed/tabbed-page-layout.component';

export const promotionalRoutes: Route[] = [
    {
        path: 'promotional-tools',
        canActivate: [AuthGuard],
        component: LayoutComponent,
        children: [
            {
                path: 'bonuses',
                component: TabbedPageLayoutComponent,
                children: [
                    {
                        data: {
                            breadcrumbs: [{ label: 'promotional.breadcrumbs.bonuses' }],
                            actions: [
                                {
                                    label: 'actions.new',
                                    execute: (componentInstance) => {
                                        componentInstance.openCreateDialog();
                                    },
                                },
                            ],
                        },
                        path: '',
                        loadComponent: () =>
                            import(
                                './pages/bonuses/promotional-bonuses.component'
                            ).then((c) => c.PromotionalBonusesListComponent),
                    },
                ],
            },
        ],
    },
];
